import { render, staticRenderFns } from "./filtroServizio.vue?vue&type=template&id=0b16682c&"
import script from "./filtroServizio.vue?vue&type=script&lang=js&"
export * from "./filtroServizio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports